import {Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import React, {Component} from "react";
import {setFormFieldValue} from "../../containers/Applications/shared/shared";
import {getData, postData} from "../../api/doLogin";
import Select from "react-select";
import "react-select/dist/react-select.min.css"

export class PermissionsUserPicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      totalResults: 0,
      options: [],
      selected: [],
      formData: {},
      showIndicator: false,
      showDialog: true,
    }
  }

  componentDidMount() {
    this.getUserList();
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   // like writing return true
  //   return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  // }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  saveUserList() {
    let self = this;
    console.log({permissions: [...this.state.selected]});
    postData(`training/${this.props.selected}/users`, {permissions: [...this.state.selected]}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.props.onClose && self.props.onClose();
        } else {

        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getUserList() {
    let self = this;
    getData(`training/${this.props.selected}/users`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          console.log(data.data);
          self.setState({
            options: data.data.users.map((user) => {
              return {
                value: user.id,
                label: `${user.lname}, ${user.fname}`,
                visible: user.visible,
                perms: user.perms,
              }
            }).sort((userA, userB) => userA.label > userB.label ? 1 : -1),
            selected: data.data.category_permissions.map((perm) => perm.uid)
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
  hasReadOnlyPerms(permission){
    if (permission[this.props.permissionType]){
      return (permission[this.props.permissionType].length > 0 && permission[this.props.permissionType].indexOf(2) === -1);
    }
    return false;
  }

  render() {
    const validOptions = this.state.options.filter((option)=>
      (option.visible===1 || this.state.selected.indexOf(option.value) > -1) && this.hasReadOnlyPerms(option.perms));
    return (
      <React.Fragment>
        {this.state.options.length > 0 && (
          <Modal isOpen={true}
                 className={'modal-md ' + this.props.className}>
            <ModalHeader>Select Users{this.props.title ? ` - ${this.props.title}` : ""}</ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label htmlFor="selectedApps">Access Permissions</Label>
                <Select
                  id="selected"
                  name="selected"
                  value={this.state.selected}
                  options={validOptions}
                  onChange={(accessPerms) => this.setState({selected: accessPerms.map(r => r.value)})}
                  multi
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="info"
                      onClick={() => this.saveUserList()}>Save</Button>
              <Button color="secondary"
                      onClick={() => this.props.onClose()}>Close</Button>
            </ModalFooter>
          </Modal>
        )}

      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Permissions/PermissionsUserPicker.js